module.exports = __webpack_public_path__ + "static/img/apnea-lab-banner-image.358e4ce.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apnea-lab-banner-image.jpeg
// module id = TuFO
// module chunks = 1